module.exports = __webpack_public_path__ + "static/media/footer.41e3cba6.svg";